<template>
    <div
        class="rounded"
        :class="{ 'bg-danger text-white': !event.ttsessiontype && !event.rgb }"
        :style="{
            backgroundColor: markAbsent ? '#E45252' : getEventBgColor(event),
            color: markAbsent ? 'white' : getEventTextColor(event),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }"
        @click="$emit('click')"
    >      
        <div
            :class="slim ? 'd-none' : hideDetailsOnSmallScreen ? 'd-inline d-md-none' : 'd-none'"
            :style="{ whiteSpace: 'nowrap' }"
        >
            <span v-if="event.from">{{ from }}</span>
            <span v-if="event.ttroom"><br>{{ event.ttroom.name }}</span>
            <span v-else-if="event.title"><em>{{ event.title }}</em></span>
            <!-- <span v-if="markAbsent"><br>{{ $t('{s}-absent', {s: ''}) }}</span> -->
            <strong v-if="event.absencetype_title || event.absencetype_id || absencetype_id"><br>{{ event.absencetype_title || showAbscenceType(event.absencetype_id || absencetype_id) }}</strong>
        </div>

        <div :class="{ 'd-none d-md-inline': hideDetailsOnSmallScreen, 'd-inline': slim }">
            <template v-if="!slim">
                <template v-if="event.from && event.to">
                    {{ `${from} - ${to}` }}
                </template>
                <template v-if="event.title">
                    <br />
                    <em>{{ event.title }}</em>
                </template>
                <span v-else-if="event.day" class="bg-event-text">
                    {{  (event.title ? `${event.title} - ` : '') + `${$t('day')} ${event.day}` }}
                </span>

            </template>
            <br v-if="!slim" />
            <span v-if="event.ttsessiontype && event.ttsessiontype.name">
                {{ event.ttsessiontype.name }}<span v-if="event.ttroom"> - {{ event.ttroom.name }}</span>
            </span>
            <span v-if="showTeacherDetails">
                {{ $t('attending-colon') }} {{ onRota + added - absent }}
                {{ $t('absent-colon') }}  {{ absent }}
            </span>
            <!-- <span v-if="markAbsent && !slim">{{ $t('{s}-absent', {s: ''}) }}</span> -->
            <strong v-if="(event.absencetype_title || event.absencetype_id || absencetype_id) && !slim"><br>{{ event.absencetype_title || showAbscenceType(event.absencetype_id || absencetype_id) }}</strong>
            <br v-if="displayGroups && eventGroups.length > 0">
            <span v-if="displayGroups && eventGroups.length > 0">
                {{ $t('groups') }} {{groupsCb(eventGroups)}}
            </span>
            <br v-if="showSharedEvents && eventProgrammes.length > 1">
            <span v-if="showSharedEvents && eventProgrammes.length > 1">
                {{ $t('shared-amongst-colon') }} {{eventProgrammes.join(',')}}
            </span>
        </div>
    </div>
</template>

<script>
import { rgbToHex, getTextColor } from 'src/modules/timetable/util'

export default {
    props: {
        event: {
            type: Object,
            required: true,
            default: () => ({ teachers: [], groups: [] })
        },
        slim: {
            type: Boolean,
            default: false,
        },
        hideDetailsOnSmallScreen: {
            type: Boolean,
            default: false,
        },
        showTeacherDetails: {
            type: Boolean,
            default: false,
        },
        showSharedEvents: {
            type: Boolean,
            default: false,
        },
        markAbsent: {
            type: Boolean,
            default: false,
        },
        absencetype_id: {
            type: Number,
            default: null
        },
        displayGroups: {
            type: Boolean,
            default: false
        },
        groupsCb: {
            type: Function,
            default: function (arr) {
                if (arr.length === 0) return "";
                
                // Sort the array numerically first
                const sorted = arr.sort((a, b) => {
                    const numA = parseInt(a.replace('G', ''));
                    const numB = parseInt(b.replace('G', ''));
                    return numA - numB;
                });
                
                const ranges = [];
                let start = sorted[0];
                let end = sorted[0];
                
                for (let i = 1; i <= sorted.length; i++) {
                    const current = sorted[i];
                    const prevNum = parseInt(end.replace('G', ''));
                    const currentNum = current ? parseInt(current.replace('G', '')) : null;
                    
                    // Check if consecutive
                    if (currentNum === prevNum + 1) {
                    end = current;
                    } else {
                    // Add the range to results
                    if (start === end) {
                        ranges.push(start);
                    } else {
                        ranges.push(`${start}-${end}`);
                    }
                    
                    // Reset for next range
                    start = current;
                    end = current;
                    }
                }
                
                return ranges.join(', ');
            }
        }
    },
    mounted() {
        if (this.event.teachers && this.showTeacherDetails) this.event.teachers.forEach(teacher => {
            if (teacher.on_rota) this.onRota++
            else this.added++

            if (teacher.substitute_id) this.subs++
            else if (teacher.absent) this.absent++
        })
    },
    data() {
        return {
            onRota: 0,
            absent: 0,
            subs: 0,
            added: 0,
            // eventProgrammes: [...new Set((this.event.groups || []).map(g => this.$config.getProgrammeNameById(g.programme_id)))],
            // eventGroups: [...new Set((this.event.groups || []).map(g => this.$config.getGroupNameById(g.group_id)))]  
        }
    },
    methods: {
        getEventBgColor(event) {
            return event.rgb
            ? rgbToHex(event.rgb[0], event.rgb[1], event.rgb[2])
            : Number(event.cancelled)
            ? '#CCC'
            : event.ttsessiontype && event.ttsessiontype.colourcode
            ? `#${event.ttsessiontype.colourcode}`
            : undefined
        },
        getEventTextColor(event) {
            return event.rgb
            ? getTextColor(null, event.rgb)
            : event.ttsessiontype && event.ttsessiontype.colourcode
            ? getTextColor(event.ttsessiontype.colourcode)
            : Number(event.cancelled)
            ? 'black'
            : 'white'
        },
        showAbscenceType(id){
            //let absences_array = ;
            return '[' + this.$config.getValue("absencetypes").filter(x => x.id == id)[0].title + ']'
        }
    },
    computed: {
        from() {
            return this.$datetime.timestampToTime(Number(this.event.from), false)
        },
        to() {
            return this.$datetime.timestampToTime(Number(this.event.to), false)
        },
        hideSmallClass() {
        	return this.hideDetailsOnSmallScreen ? 'd-none d-md-inline' : ''
        },
        showSmallClass() {
            return this.hideDetailsOnSmallScreen ? 'd-inline d-md-none' : ''
        },
        eventProgrammes() {
            return [...new Set((this.event.groups || []).map(g => this.$config.getProgrammeNameById(g.programme_id)))]
        },
        eventGroups() {
            return [...new Set((this.event.groups || []).map(g => this.$config.getGroupNameById(g.group_id)))]
        }
    }
}
</script>

<style scoped lang="scss">
.bg-event-text {
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
